<template>
<div class="card" @click="clicked">
  <div class="card-image" v-if="image">
    <slot name="image">
    </slot>
  </div>
  <div class="card-content" :class="{ 'no-padding': noPadding }">
    <slot></slot>
  </div>
  <div class="card-footer" v-if="footer">
    <slot name="footer">
    </slot>
  </div>
</div>
</template>

<script>
export default {
  props: {
    noPadding: {
      type: Boolean,
      default: false
    },
    image: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clicked () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.card-content {
  color: $black;
  padding: 1rem;
  &.no-padding {
    padding: 0;
  }
}

.card-footer {
  border-top: 0;
}

.card.no-border {
  border: 0;

  .card-content {
    border: 1px solid #ddd;
    border-top: none;
  }
  .card-footer {
    border: 1px solid #ddd;
    border-top: none;
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
}

.card .media:not(:last-child) {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/general/card.vue